export enum ORDER_STATUS {
	INIT = "init",
	OPENED = "opened",
	ACCEPTED = "accepted",
	CANCELED = "canceled",
	CLOSED = "closed"
}
